import React from "react";
import BotonContactar from "../../components/layouts/boton/BotonContactar";
import ServiceTop from "../../components/layouts/ServiceTop";
import { Content } from "../../components/toggleDescComp/Content";

//image
import capacitacion from "../../images/servicios/capacitación_blanco.png";
import secCapacitacion from "../../images/servicios/sec_capacitacion.png";

import { CapacitacionU } from "../../utils/itemsToogle";

export default function Capacitacion() {
  return (
    <>
      <ServiceTop
        image={capacitacion}
        title="Capacitacion."
        text={`Somos DC-5 y todos nuestros cursos están registrados ante la STPS, por 
        lo cual entregamos los DC-3 correspondientes a los participantes que aprueben las evaluaciones al 
        final de los cursos.
        Todos nuestros cursos están diseñados para generar las mejores prácticas de operación y 
        optimización en el uso de los recursos.`}
        secImage={secCapacitacion}
      />
      <div>
        <Content items={CapacitacionU} />
      </div>
      <BotonContactar />
    </>
  );
}
